(function ($) {
    // only for tablet and more
    function zeroPad(num, places) {
        var zero = places - num.toString().length + 1;
        return Array(+(zero > 0 && zero)).join("0") + num;
    }
    function preload(arrayOfImages) {
        $(arrayOfImages).each(function(){
             (new Image()).src = this;
        });
    }
    if ($(window).width()>=768){


        $('body').on('click', '.scroller-animated', function(e) {

            var el = $(this),
                target = $(this.hash);
            if (target.length) {
                var offset = target.offset().top,
                    visuals = el.closest('.visuals-animate');
                if(visuals.length){
                    var frameCount = (visuals.data('frame_count') != null) ? visuals.data('frame_count') : 0;
                    console.log('1');
                    if (frameCount > 0){
                        var scrollDelta = frameCount * 80 * 0.735;
                    } else {
                        var scrollDelta = $(window).height()*2;
                    }
                } else {
                    visuals = el.closest('.animation-container');
                    if(visuals.length){
                        var views = visuals.find('.animation-view'),
                            viewsCount = views.length,
                            parent = el.closest('.scrollmagic-pin-spacer'),
                            parentHeight = parent.outerHeight(),
                            scrollDelta = parentHeight / viewsCount;

                        /*var frameCount = (visuals.data('frame_count') != null) ? visuals.data('frame_count') : 0;
                        console.log(parentHeight);
                        if (frameCount > 0){
                            var scrollDelta = frameCount * 80 * 0.735;
                        } else {
                            var scrollDelta = $(window).height()*2;
                        }*/
                    }
                }
                $('html,body').animate({
                    scrollTop: offset
                }, 1000, function () {
                    if(!el.hasClass('simple-scroll')){
                        $('html,body').animate({
                            scrollTop: scrollDelta
                        }, 1000);
                    }
                });
                return false;
            }
            /*var id = $(this).attr("href"); // grab the href attribute value

            if($(id).length > 0) {
                // prevents default behavior of links.
                e.preventDefault();

                // trigger scroll
                controller.scrollTo(id);
            }*/

        });

        var updateDotNavItem = function (item) {
            var parent = item.closest('.animation-container'),
                root = parent.parent(),
                nav = root.find('.nav-dots-container'),
                navItem = nav.find('.nav-dots__item'),
                items = parent.find('.animation-view'),
                itemIndex = items.index(item);
            navItem.removeClass('active');
            $(navItem.get(itemIndex)).addClass('active');
        };

        var initDotNav = function (item) {
            var items = item.find('.animation-view'),
                navContainer = $('<div class="nav-dots-container"></div>').appendTo(item);
            items.each(function (idx, item) {
                var el = $(this),
                    id = el.attr('id');
                $('<a class="nav-dots__item" data-id="'+idx+'" href="#'+id+'"><span></span></a>').appendTo(navContainer);
            });
        };

        $(document).on('click', '.nav-dots__item', function (e) {
            var el = $(this),
                parent = el.closest('.scrollmagic-pin-spacer'),
                parentHeight = parent.outerHeight(),
                counter = parent.find('.animation-view').length,
                href = el.attr('href'),
                target = $(href),
                height = $(window).height(),
                heightDelta = parentHeight/counter,
                step = heightDelta / height,
                id = el.data('id'),
                delta = height * id,
                scrollTop = $(document).scrollTop();

            if (target.length) {
                var offset = (parent.offset().top + delta * step)*0.98,
                    scrollDelta = Math.abs(offset-scrollTop);

                /*console.log("parent",parent);
                console.log("parentHeight", parentHeight);
                console.log("counter", counter);
                console.log("height", height);
                console.log("heightDelta", heightDelta);
                console.log("step", step);
                console.log("delta", delta);*/

                $('html,body').animate({
                    scrollTop: offset
                }, scrollDelta/2);
                return false;
            }
        });

        // Add advanced animated scroll feature
        $('.link-arrow-ani').addClass('scroller-animated');
        
        // Vertical Bar animation
        var bar_vertical = function (item) {
            var el = $(item),
                start = el.data('start'),
                finish = el.data('finish'),
                progressbar = el.find('.bar-progress'),
                progressbar_text = el.find('.bar-txt');
            new TimelineMax()
                .fromTo(progressbar, Math.abs(Math.max(finish, start) - Math.min(finish, start))/50, {height: start+"%"}, {height: finish+"%", onUpdate:function (e) {
                    progressbar_text.text(parseInt(progressbar[0].style.height)+"%");
                }});
        };

        var bar_vertical_reset = function (item) {
            var el = $(item);
            el.find('.bar-progress').css({height:el.data('start')+"%"});
            el.find('.bar-txt').text(el.data('start')+"%");
        };
        
        // Horizontal Bar animation
        var bar_horizontal = function (item) {
            var el = $(item),
                start = el.data('start'),
                finish = el.data('finish'),
                progressbar = el,
                progressbar_text = el.find('span');
            //console.log(Math.abs(Math.max(finish, start) - Math.min(finish, start)));
            new TimelineMax()
                .fromTo(progressbar, Math.abs(Math.max(finish, start) - Math.min(finish, start))/50, {width: start+"%"}, {width: finish+"%", onUpdate:function (e) {
                    progressbar_text.text(parseInt(progressbar[0].style.width)+"%", 0);
                }});
        };

        // Horizontal Double Bar animation
        var bar_horizontal_double = function (item) {
            var el = $(item),
                start = el.data('start'),
                finish = el.data('finish'),
                progressbar1 = el.find('.progress-value-first'),
                progressbar2 = el.find('.progress-value-second');
            new TimelineMax()
                .add("start", 0)
                .fromTo(progressbar1, Math.abs(Math.max(finish, start) - Math.min(finish, start))/50, {width: start+"%"}, {width: finish+"%", onUpdate:function (e) {
                    progressbar1.text(parseInt(progressbar1[0].style.width)+"%", 0);
                }}, "start")
                .fromTo(progressbar2, Math.abs(Math.max(finish, start) - Math.min(finish, start))/50, {width: (100-start)+"%"}, {width: (100-finish)+"%", onUpdate:function (e) {
                    progressbar2.text(parseInt(progressbar2[0].style.width)+"%",0);
                }}, "start");
        };

        // Horizontal Double Bar animation
        var bar_horizontal_double_ex = function (item) {
            var el = $(item),
                start = el.data('start'),
                finish = el.data('finish'),
                progressbar1 = el.find('.progress-bar'),
                progressbar1_text = progressbar1.find('i'),
                progressbar2 = el.find('.progress-txt i');
            new TimelineMax()
                .add("start", 0)
                .fromTo(progressbar1, Math.abs(Math.max(finish, start) - Math.min(finish, start))/50, {width: start+"%"}, {width: finish+"%", onUpdate:function (e) {
                    progressbar1_text.text(parseInt(progressbar1[0].style.width)+"%", 0);
                }}, "start")
                /*.fromTo(progressbar2, 1, {width: (100-start)+"%"}, {width: (100-finish)+"%", onUpdate:function (e) {
                    progressbar2.text(parseInt(progressbar2[0].style.width)+"%",0);
                }}, "start");*/
        };

        var reset_bar_horizontal_double_ex = function (item) {
            var el = item,
                start = el.data('start'),
                finish = el.data('finish'),
                progressbar1 = el.find('.progress-bar'),
                progressbar1_text = progressbar1.find('i');

                //progressbar2 = el.find('.progress-value-second');

            progressbar1.css({width:start+"%"});
            //progressbar2.css({width:(100-start)+"%"});
            progressbar1_text.text(parseInt(start)+"%", 0);
            //progressbar2.text(parseInt(progressbar2[0].style.width)+"%", 0);
        };

        // Horizontal Double Bar reset
        var reset_bar_horizontal_double = function (item) {
            var el = $(item),
                start = el.data('start'),
                finish = el.data('finish'),
                progressbar1 = el.find('.progress-value-first'),
                progressbar2 = el.find('.progress-value-second');

            progressbar1.css({width:start+"%"});
            progressbar2.css({width:(100-start)+"%"});
            progressbar1.text(parseInt(progressbar1[0].style.width)+"%", 0);
            progressbar2.text(parseInt(progressbar2[0].style.width)+"%", 0);
        };
        // Horizontal Double Bar reset
        var reset_bar_horizontal = function (item) {
            var el = $(item);
            el.css({width: el.data('start')+"%"});
            el.find('span').text(el.data('start')+"%");
        };

        var reset_poiner = function (item) {
            var el = $(item);
            el.css({width:0, opacity: 0});
            el.find('.pointer').css({width:0});
        };

        var set_pointer = function (item) {
            var el = $(item),
                value = el.data("value"),
                subel = el.find(".pointer");
            if (subel.length){
                var subel_value = subel.data("value");
                new TimelineMax()
                    .add("start", 0)
                    .to(el, 0.2, {opacity:1}, "start")
                    .to(el, 0.8, {width:value}, "start")
                    .to(subel, 0.2, {opacity:1}, "start")
                    .to(subel, 0.8, {width:subel_value}, "start");
            } else {
                new TimelineMax()
                    .add("start", 0)
                    .to(el, 0.2, {opacity:1}, "start")
                    .to(el, 0.8, {width:value}, "start");
            }

        };

        var set_pointer = function (item) {
            var el = $(item),
                value = el.data("value"),
                subel = el.find(".pointer");
            if (el.hasClass('pointer-vw')){
                if (subel.length){
                    var subel_value = subel.data("value");
                    new TimelineMax()
                        .add("start", 0)
                        .to(el, 0.2, {opacity:1}, "start")
                        .to(el, 0.8, {width:value+'vw'}, "start")
                        .to(subel, 0.2, {opacity:1}, "start")
                        .to(subel, 0.8, {width:subel_value+'vw'}, "start");
                } else {
                    new TimelineMax()
                        .add("start", 0)
                        .to(el, 0.2, {opacity:1}, "start")
                        .to(el, 0.8, {width:value+'vw'}, "start");
                }
            } else {
                if (subel.length){
                    var subel_value = subel.data("value");
                    new TimelineMax()
                        .add("start", 0)
                        .to(el, 0.2, {opacity:1}, "start")
                        .to(el, 0.8, {width:value}, "start")
                        .to(subel, 0.2, {opacity:1}, "start")
                        .to(subel, 0.8, {width:subel_value}, "start");
                } else {
                    new TimelineMax()
                        .add("start", 0)
                        .to(el, 0.2, {opacity:1}, "start")
                        .to(el, 0.8, {width:value}, "start");
                }
            }


        };

        var controller = new ScrollMagic.Controller({
            globalSceneOptions: {
                triggerHook: 0,
                //reverse: true
            }
        });

        var pantherisContainer = $('.pantheris-container'),
            ocelotContainer = $('.ocelot-container'),
            ocelotContainerAmazing = $('.ocelot-container-amazing'),
            lightboxContainer = $('.lightbox-container'),
            visualsAnimate = $('.visuals-animate'),
            videoBgFixed = $('.video-bg-placeholder'),
            physicans1 = $('#physicans-1'),
            physicans2 = $('#physicans-2'),
            physicans1_played = false,
            physicans2_played = false,
            lumivascular = $('.lumivascular-container'),
            lumivascular0 = $('#lumivascular-0'),
            lumivascular1 = $('#lumivascular-1'),
            lumivascular2 = $('#lumivascular-2'),
            lumivascular1_played = false,
            lumivascular2_played = false,
            radiation = $('.section-radiation'),
            flurocopy = $('.section-fluorocopy');

        if (radiation.length){
            var radiationList = radiation.find('.list-def li');
            if (radiationList.length){
                new TimelineMax()
                    .set(radiationList, {left: '100%', opacity: 0})

                var radiationAnimation1 = new TimelineMax(),
                    speed_1 = 4,
                    speed_2 = 3,
                    speed_3 = 2,
                    speed = 0.6,
                    frame_count  = radiation.data('frame_count'),
                    offset_value = 80;
                
                radiationList.each(function (index, item) {
                    radiationAnimation1
                        .to($(this), speed, {opacity: 1, left: 0}, "-=0.3")
                });

                new ScrollMagic.Scene({
                    triggerElement: '.section-radiation',
                    // triggerHook:0,
                    /*offset: '-50%',
                    duration: 0,*/
                    triggerHook:'onEnter',
                    duration: (frame_count * offset_value) + 'px',
                    reverse: true
                })
                    .setPin('.section-radiation .container')
                    .setTween(radiationAnimation1)
                    .addTo(controller);
            }
        }

        if(flurocopy.length){
            var flurocopyList = flurocopy.find('.circle-progress-b');

            if(flurocopyList.length){
                flurocopyList.each(function (index, item) {
                    $(this).circleProgress({ value: 0});
                });

                new ScrollMagic.Scene({
                    triggerElement: '.section-fluorocopy',
                    triggerHook: 0.5,
                    offset: -200,
                    duration: 100,
                })
                    .addTo(controller)
                    .on('enter', function (e) {
                        flurocopyList.each(function (index, item) {
                            $(this).circleProgress({ value: $(this).data("value")});
                        });
                    });
            }
        }

        if (lumivascular.length){
            if (visualsAnimate.length){

                visualsAnimate.addClass('visual-animated');
                var visuals = visualsAnimate.find('.visuals-item'),
                    speed_1 = 4,
                    speed_2 = 3,
                    speed_3 = 1,
                    frame_count  = visualsAnimate.data('frame_count'),
                    offset_value = 80;
                visuals.slice(1).css({opacity:0, zIndex:0});

                var lumi_pin = lumivascular1.find('.media-body li');
                lumi_pin.css({opacity:0});

                var circleBars = lumivascular2.find('.circle-progress, .circle-progress-a'),
                    bars = lumivascular2.find('.bar-v'),
                    bars2 = lumivascular2.find('.progress-lg'),
                    progressBars = lumivascular2.find('.progress-bar');

                circleBars.each(function (e) {
                    $(this).circleProgress({ value: 0});
                });

                bars.each(function (e) {
                    bar_vertical_reset($(this));
                });
                bars2.each(function (e) {
                    reset_bar_horizontal_double($(this));
                });

                progressBars.each(function (e) {
                    reset_bar_horizontal($(this));
                });

                var visualsAnimation = new TimelineMax();

                visualsAnimation
                    .set(lumivascular0, {zIndex: 1}, "-=3.0")
                    .fromTo(lumivascular0, speed_1, {y:30}, {opacity: '1', y:0, ease: Linear.easeNone}, "-=1.0")
                    .to(lumivascular0, speed_1, {opacity: '0', y: -30, ease: Linear.easeNone})
                    .set(lumivascular1, {zIndex: 1}, "-=3.0")
                    .fromTo(lumivascular1, speed_1, {y:30}, {opacity: '1', y:0, ease: Linear.easeNone}, "-=1.0")
                    //.to(lumivascular1.find('.visual-item-wrap'), speed_1, {opacity: '0', y: -30, ease: Linear.easeNone});

                lumi_pin.each(function () {
                    var el = $(this);
                    visualsAnimation.to(el, speed_1, {opacity: '1', ease: Linear.easeNone});
                });

                visualsAnimation
                    .to(lumivascular1.find('.visual-item-wrap'), speed_2, {opacity: '1', ease: Linear.easeNone})
                    .to(lumivascular1.find('.visual-item-wrap'), speed_1, {opacity: '0', y: -30, ease: Linear.easeNone})
                    .set(lumivascular2, {zIndex: 1}, "-=3.0")
                    .fromTo(lumivascular2, speed_1, {y:30}, {opacity: '1', y:0, ease: Linear.easeNone,
                        onComplete: function(){
                            if(!lumivascular2_played){
                                lumivascular2_played = !lumivascular2_played;

                                circleBars.each(function (e) {
                                    $(this).circleProgress({ value: $(this).data("value")});
                                });

                                bars.each(function (e) {
                                    bar_vertical($(this));
                                });

                                progressBars.each(function (e) {
                                    bar_horizontal($(this));
                                });

                                bars2.each(function (e) {
                                    bar_horizontal_double($(this));
                                });
                            }
                        }
                    }, "-=1.0")
                    .to(lumivascular2, speed_1, {opacity: '1', ease: Linear.easeNone});

                // build pinned scene
                new ScrollMagic.Scene({
                    triggerElement: '.visuals-animate',
                    triggerHook:'onEnter',
                    duration: (frame_count * offset_value) + 'px',
                    reverse: true
                })
                    .setPin('.visuals-animate')
                    .setTween(visualsAnimation)
                    .addTo(controller);
            }
        }


        if (physicans1.length){

            var circleBars = physicans1.find('.circle-progress, .circle-progress-a'),
                bars = physicans1.find('.bar-v'),
                progressBars = physicans1.find('.progress-bar');

            circleBars.each(function (e) {
                $(this).circleProgress({ value: 0});
            });

            bars.each(function (e) {
                bar_vertical_reset($(this));
            });

            progressBars.each(function (e) {
                reset_bar_horizontal($(this));
            });

            new ScrollMagic.Scene({
                triggerElement: "#physicans-1",
                offset: -($(window).height()/2)
            })
                .on('start', function (e) {
                    if(!physicans1_played){
                        physicans1_played = !physicans1_played;
                        
                        circleBars.each(function (e) {
                            $(this).circleProgress({ value: $(this).data("value")});
                        });

                        bars.each(function (e) {
                            bar_vertical($(this));
                        });

                        progressBars.each(function (e) {
                            bar_horizontal($(this));
                        });
                    }
                })
                .addTo(controller);
        }

        if(physicans2.length){

            var circleBars2 = physicans2.find('.circle-progress'),
                bars2 = physicans2.find('.progress-lg');

            circleBars2.each(function (e) {
                $(this).circleProgress({ value: 0});
            });

            bars2.each(function (e) {
                reset_bar_horizontal_double($(this));
            });

            new ScrollMagic.Scene({
                triggerElement: "#physicans-2",
                offset: -($(window).height()/2)
            })
                .on('start', function (e) {
                    if(!physicans2_played){
                        physicans2_played = !physicans2_played;

                        circleBars2.each(function (e) {
                            $(this).circleProgress({ value: $(this).data("value")});
                        });

                        bars2.each(function (e) {
                            bar_horizontal_double($(this));
                        });
                    }
                })
                .addTo(controller);
        }
        
        if (videoBgFixed.length){
            videoBgFixed.addClass('video-fixed');
        }
        
        if (visualsAnimate.length){
            if (!visualsAnimate.hasClass('visuals-animate-custom')) {
                visualsAnimate.addClass('visual-animated');
                var visuals = visualsAnimate.find('.visuals-item'),
                    speed_1 = 4,
                    speed_2 = 2,
                    frame_count  = visualsAnimate.data('frame_count'),
                    offset_value = 80;
                visuals.slice(1).css({opacity:0, zIndex:0});

                var visualsAnimation = new TimelineMax();

                visuals.each(function (item) {
                    var el = $(this),
                        bgSolid = false;
                    if (el.hasClass('bg-solid')){
                        bgSolid = true;
                        var elInner = el.find('.visual-item-wrap');
                    }

                    if (item > 0){
                        visualsAnimation.set(el, {zIndex: 1}, "-=3.0");
                        visualsAnimation.fromTo(el, speed_1, {y:30}, {opacity: '1', y:0, ease: Linear.easeNone}, "-=1.0");
                    }
                    if (item != (visuals.length - 1)){
                        if (bgSolid && elInner.length){
                            visualsAnimation.to(elInner, speed_1, {opacity: '0', y: -30, ease: Linear.easeNone});
                        } else {
                            visualsAnimation.to(el, speed_1, {opacity: '0', y: -30, ease: Linear.easeNone});
                        }
                    }
                    if(item == (visuals.length - 1)){
                        if (bgSolid && elInner.length){
                            visualsAnimation.to(elInner, speed_2, {opacity: '1', ease: Linear.easeNone});
                        } else {
                            visualsAnimation.to(el, speed_2, {opacity: '1', ease: Linear.easeNone});
                        }
                    }
                });

                // build pinned scene
                new ScrollMagic.Scene({
                    triggerElement: '.visuals-animate',
                    triggerHook:'onEnter',
                    duration: (frame_count * offset_value) + 'px',
                    reverse: true
                })
                    .setPin('.visuals-animate')
                    .setTween(visualsAnimation)
                    .addTo(controller);
            }
        }

        
        var vid = $('#bgvid, .bgvid'),
            video_bg = vid[0];
        if (vid.length){
            if (video_bg.paused){
                vid[0].play();
            }
        }

        if (lightboxContainer.length){
            var totalImagesCount = 29,
                frameDuration = 30,
                vid = $('#lightbox-video'),
                sprites = [];

            // define sprites
            for (var i=4; i <totalImagesCount; i++){
                sprites.push( avinger_theme_directory + "assets/images/lightbox/"+zeroPad(i, 3)+".jpg");
            }
            preload(sprites);

            lightboxContainer.find('.animation-container').addClass('animated');
            var lightbox1 = lightboxContainer.find('#lightbox-1'),
                lightbox1_right = lightbox1.find('.ani-right'),
                lightbox2 = lightboxContainer.find('#lightbox-2'),
                lightbox2_right = lightbox2.find('.ani-right'),
                lightbox3 = lightboxContainer.find('#lightbox-3'),
                lightbox3_right = lightbox3.find('.ani-right'),
                lightbox4 = lightboxContainer.find('#lightbox-4'),
                lightbox4_right = lightbox4.find('.ani-right'),
                lightbox5 = lightboxContainer.find('#lightbox-5'),
                lightbox5_right = lightbox5.find('.ani-right'),
                lightbox6 = lightboxContainer.find('#lightbox-6'),
                lightbox6_right = lightbox6.find('.ani-right'),
                circleBar1 = lightbox2.find('#circle-bar-1'),
                circleBar2 = lightbox2.find('#circle-bar-2'),
                circleBar3 = lightbox2.find('#circle-bar-3'),
                circleBar4 = lightbox2.find('#circle-bar-4'),
                progressBar1 = lightbox3.find('#progress-bar-1'),
                doubleBar1 = lightbox2.find('#bar-double-1'),
                lightbox2_completed = false,
                frame_count  = 80,
                offset_value = 80,
                speed_1 = 4;

            initDotNav(lightboxContainer);
            circleBar1.circleProgress({ value: 0 });
            circleBar2.circleProgress({ value: 1 });
            circleBar3.circleProgress({ value: 0 });
            circleBar4.circleProgress({ value: 0 });

            reset_bar_horizontal(progressBar1);
            reset_bar_horizontal_double_ex(doubleBar1);
            $('.product-lightbox .ani-right > .pointer').each(function () {
                reset_poiner(this);
            });

            var lightboxImgTimeLine = new TimelineMax({ paused: true }),
                lightboxImgHolder = $("#lightbox-video-frame"),
                lightboxAnimationImages = {tick :0};

            var lightboxAnimation = new TimelineMax()
                .add("scene1", 0)
                .add("scene2", 2)
                .add("scene2_progress", 2)
                .add("scene2_end", 2)
                .add("scene3", 4)
                .add("scene3_end", 16)
                .add("scene4", 18)
                .add("scene4_end", 22)
                .add("scene5", 24)
                .add("scene5_end", 28)
                .add("scene6", 30)
                .add("scene6_end", 34)
                .set(lightbox2, {display:'table'}, "scene1")
                .to(lightbox1_right, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone}, "scene1")  // in from left
                .set(lightbox2, {zIndex: 1}, "scene2")
                .fromTo(lightboxAnimationImages, speed_1, {tick: 0}, {tick:14, onUpdate: function () {
                    $("#lightbox-video-frame").attr("src", sprites[Math.round(lightboxAnimationImages.tick)]); // set the image source
                }}, "scene2")
                .fromTo(lightbox2_right, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone,
                    onComplete: function(){
                        if (!lightbox2_completed){
                            lightbox2_completed = true;
                            circleBar1.circleProgress({ value: circleBar1.data("value") });
                            circleBar2.circleProgress({ value: circleBar2.data("value") });
                            circleBar3.circleProgress({ value: circleBar3.data("value") });
                            circleBar4.circleProgress({ value: circleBar4.data("value") });
                            bar_horizontal("#progress-bar-1");
                            bar_horizontal_double_ex(doubleBar1);
                        }
                        /*for (var i = 0; i <= 14; i++) {
                            lightboxImgTimeLine.set(lightboxImgHolder, {attr:{src:sprites[i]}}, i);
                        }
                        TweenMax.to(lightboxImgTimeLine, 1, { progress:1, ease:Linear.easeNone});*/
                        updateDotNavItem(lightbox2);
                    },
                    onReverseComplete: function () {
                        updateDotNavItem(lightbox2);
                    }
                }, "scene2")
                .set(lightbox3, {display:'table'}, "scene2_end")
                .to(lightbox2_right, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone,
                        onReverseComplete: function () {
                        updateDotNavItem(lightbox2);
                    }
                },  "scene2_end")
                .set(lightbox3, {zIndex: 1}, "scene3")
                .fromTo(lightbox3_right, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone, onComplete: function(){
                    set_pointer("#lightbox-3 .ani-right > .pointer.pointer-vw");
                    updateDotNavItem(lightbox3);
                }}, "scene3")
                .set(lightbox4, {display:'table'}, "scene3_end")
                .fromTo(lightboxAnimationImages, speed_1, {tick: 14}, {tick:0,
                    onUpdate: function () {
                        $("#lightbox-video-frame").attr("src", sprites[Math.round(lightboxAnimationImages.tick)]); // set the image source
                    },
                    onReverseComplete: function () {
                        updateDotNavItem(lightbox3);
                    },
                    onComplete: function(){
                        updateDotNavItem(lightbox4);
                    }
                }, "scene3_end")
                /*.to(lightbox3_right, speed_1, {opacity: "1", ease: Linear.easeNone,
                    onReverseComplete: function () {
                        updateDotNavItem(lightbox3);
                    },
                    onComplete: function () {
                        for (var i = 14; i >= 0; i--) {
                            lightboxImgTimeLine.set(lightboxImgHolder, {attr:{src:sprites[i]}}, i);
                        }
                        TweenMax.to(lightboxImgTimeLine, 1, { progress:1, ease:Linear.easeNone});
                    }
                },  "scene3_end")*/
                /*.to(lightbox3_right, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone,onReverseComplete: function () {
                    updateDotNavItem(lightbox3);
                }},  "scene3_end")*/

                /*.set(lightbox4, {zIndex: 1}, "scene4")
                .fromTo(lightbox4_right, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone, onComplete: function(){
                    set_pointer("#lightbox-4 .ani-right > .pointer");
                    updateDotNavItem(lightbox4);
                }}, "scene4")*/
                .set(lightbox5, {display:'table'}, "scene4_end")
                .to(lightbox3_right, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone,
                    onReverseComplete: function () {
                        updateDotNavItem(lightbox4);
                    }},  "scene4_end")

                .set(lightbox5, {zIndex: 1}, "scene5")
                .fromTo(lightbox5_right, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone, onComplete: function(){
                    set_pointer("#lightbox-5 .ani-right > .pointer");
                    updateDotNavItem(lightbox5);
                }}, "scene5")
                .set(lightbox6, {display:'table'}, "scene5_end")
                .to(lightbox5_right, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone,
                    onReverseComplete: function () {
                        updateDotNavItem(lightbox5);
                    }},  "scene5_end")

                .set(lightbox6, {zIndex: 1}, "scene6")
                .fromTo(lightboxAnimationImages, speed_1, {tick: 0}, {tick:14, onUpdate: function () {
                    $("#lightbox-video-frame").attr("src", sprites[Math.round(lightboxAnimationImages.tick)]); // set the image source
                }}, "scene6")
                .to(vid, speed_1, {y: "-50%", ease: Linear.easeNone},  "scene6")
                .fromTo(lightbox6_right, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone, onComplete: function(){
                    set_pointer("#lightbox-6 .ani-right > .pointer");
                    updateDotNavItem(lightbox6);
                }}, "scene6")
                .to(lightbox6_right, speed_1, {opacity: "1", ease: Linear.easeNone},  "scene6_end")

            // build pinned scene
            new ScrollMagic.Scene({
                triggerElement: '.lightbox-container',
                triggerHook:'onEnter',
                duration: (frame_count * offset_value) + 'px',
                reverse: true
            })
                .on('start', function (e) {
                    updateDotNavItem(lightbox1);
                    $(".lightbox-container").toggleClass("pinned");
                })
                .on("end", function (e) {
                    $(".lightbox-container").toggleClass("pinned");
                })
                .setPin('.lightbox-container')
                .setTween(lightboxAnimation)
                .addTo(controller);

            var obj = {curImg: 0};

            // create tween
            /*var tween = TweenMax.to(obj, 1,
                {
                    curImg: sprites.length - 1,	// animate propery curImg to number of images
                    roundProps: "curImg",				// only integers so it can be used as an array index
                    repeat: 1,									// repeat 3 times
                    immediateRender: true,			// load first image automatically
                    ease: Linear.easeNone,			// show every image the same ammount of time
                    onUpdate: function () {
                        $("#lightbox-video-frame").attr("src", sprites[obj.curImg]); // set the image source
                    }
                }
            );

            new ScrollMagic.Scene({triggerElement: ".lightbox-container", duration: (frame_count * offset_value) + 'px'})
                .setTween(tween)
                .addTo(controller);
*/
        }
        
        if (ocelotContainerAmazing.length){

            ocelotContainerAmazing.find('.animation-container').addClass('animated');
            var ocelot6 = ocelotContainerAmazing.find('#ocelot-6'),
                ocelot7 = ocelotContainerAmazing.find('#ocelot-7'),
                ocelot8 = ocelotContainerAmazing.find('#ocelot-8'),
                ocelot9 = ocelotContainerAmazing.find('#ocelot-9'),
                ocelot7_top = ocelot7.find('.ani-top'),
                ocelot7_bottom = ocelot7.find('.ani-bottom'),
                ocelot8_top = ocelot8.find('.ani-top'),
                ocelot8_bottom = ocelot8.find('.ani-bottom'),
                ocelot6_top = ocelot6.find('.ani-top'),
                ocelot6_bottom = ocelot6.find('.ani-bottom'),
                ocelotDevice_1 = ocelot6_bottom.find('#device-1'),
                ocelotDevice_2 = ocelot6_bottom.find('#device-2'),
                ocelotDevice_3 = ocelot6_bottom.find('#device-3'),
                ocelotDevice_1_text = ocelot6_bottom.find('#device-1-text'),
                ocelotDevice_2_text = ocelot6_bottom.find('#device-2-text'),
                ocelotDevice_3_text = ocelot6_bottom.find('#device-3-text'),
                ocelotDevice_1_content = ocelotDevice_1_text.find('p'),
                ocelotDevice_2_content = ocelotDevice_2_text.find('p'),
                ocelotDevice_3_content = ocelotDevice_3_text.find('p'),
                ocelot9_top = ocelot9.find('.ani-top'),
                ocelot9_bottom = ocelot9.find('.ani-bottom'),
                frame_count  = 100,
                offset_value = 80,
                speed_1 = 4,
                speed_2 = 3,
                speed_3 = 2;

            initDotNav(ocelotContainerAmazing);
            var ocelotAnimationAmazing = new TimelineMax()
                .add("scene1", 2)
                .add("scene1_1", 5)
                .add("scene2", 7)
                .add("scene2_1", 10)
                .add("scene3", 12)
                .add("scene3_1", 15)
                .add("scene4", 14)
                .add("scene4_1", 17)
                //.set(ocelot7, {display:'table'}, "scene1")
                //.to(ocelot6_top, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone}, "scene1")
                .set(ocelotDevice_1, {transformOrigin:"0% 50%"})
                .set(ocelotDevice_2, {transformOrigin:"0% 50%"})
                .set(ocelotDevice_3, {transformOrigin:"0% 50%"})
                .set(ocelotDevice_1, {zIndex: 0})
                .set(ocelotDevice_2, {zIndex: -1})
                .set(ocelotDevice_3, {zIndex: -1})
                .to(ocelotDevice_1, speed_1, {/*top: "28%", */opacity: 1, scale: 1.01, ease: Linear.easeNone}, "scene1")
                .to(ocelotDevice_2, speed_1, {/*top: "-2%",*/ opacity: 0.8, scale: 0.9,  ease: Linear.easeNone}, "scene1")
                .to(ocelotDevice_3, speed_1, {/*top: "58%",*/ opacity: 0.8, scale: 0.9,  ease: Linear.easeNone}, "scene1")
                .to(ocelotDevice_1_text, speed_2, {/*top: "28%",*/ /*y:-20,*/ ease: Linear.easeNone,
                    onComplete: function () {
                        updateDotNavItem(ocelot7);
                    },
                    onReverseComplete: function () {
                        updateDotNavItem(ocelot6);
                    }
                }, "scene1")
                .to(ocelotDevice_1_content, speed_3, {maxHeight:'none', opacity: 1, ease: Linear.easeNone}, "scene1_1")
                .to(ocelotDevice_2_text, speed_3, {y:-20, opacity: 0, ease: Linear.easeNone}, "scene1")
                .to(ocelotDevice_3_text, speed_3, {y:-20, opacity: 0, ease: Linear.easeNone}, "scene1")
                .set(ocelotDevice_2_text, {top: "28%", y: 20}, "scene2")
                .set(ocelotDevice_3_text, {top: "28%", y: 20}, "scene2")
                .set(ocelotDevice_1, {zIndex: -1}, "scene2")
                .set(ocelotDevice_2, {zIndex: 0}, "scene2")
                .set(ocelotDevice_3, {zIndex: -1}, "scene2")
                .to(ocelotDevice_2, speed_1, {/*top: "28%", */opacity: 1, scale: 1.01, ease: Linear.easeNone,
                    onComplete: function () {
                        updateDotNavItem(ocelot8);
                    },
                    onReverseComplete: function () {
                        updateDotNavItem(ocelot7);
                    }}, "scene2")
                .to(ocelotDevice_2_content, speed_3, {maxHeight:'none', opacity: 1, ease: Linear.easeNone}, "scene2_1")
                .to(ocelotDevice_3, speed_1, {/*top: "-2%", */opacity: 0.8, scale: 0.9,  ease: Linear.easeNone}, "scene2")
                .to(ocelotDevice_1, speed_1, {/*top: "58%", */opacity: 0.8, scale: 0.9,  ease: Linear.easeNone}, "scene2")

                .to(ocelotDevice_1_text, speed_2, {top: "28%", y:-40, opacity: 0, ease: Linear.easeNone}, "scene2")
                .to(ocelotDevice_2_text, speed_2, {top: "28%", y:-20, opacity: 1, ease: Linear.easeNone}, "scene2")
                .set(ocelotDevice_1_text, {top: "28%", y: 20}, "scene3")
                .set(ocelotDevice_3_text, {top: "28%", y: 20}, "scene3")
                //.set(ocelotDevice_3_text, {top: "28%", y: 20}, "scene3")

                .set(ocelotDevice_1, {zIndex: -1}, "scene3")
                .set(ocelotDevice_3, {zIndex: -1}, "scene3")
                .set(ocelotDevice_2, {zIndex: 0}, "scene3")
                .to(ocelotDevice_3, speed_1, {/*top: "28%",*/ opacity: 1, scale: 1.01, ease: Linear.easeNone,
                    onComplete: function () {
                        updateDotNavItem(ocelot9);
                    },
                    onReverseComplete: function () {
                        updateDotNavItem(ocelot8);
                    }}, "scene3")
                .to(ocelotDevice_3_content, speed_3, {maxHeight:'none', opacity: 1, ease: Linear.easeNone}, "scene3_1")
                .to(ocelotDevice_2, speed_1, {/*top: "-2%",*/ opacity: 0.8, scale: 0.9,  ease: Linear.easeNone}, "scene3")
                .to(ocelotDevice_1, speed_1, {/*top: "58%",*/ opacity: 0.8, scale: 0.9,  ease: Linear.easeNone}, "scene3")

                .to(ocelotDevice_2_text, speed_2, {top: "28%", y:-40, opacity: 0, ease: Linear.easeNone}, "scene3")
                .to(ocelotDevice_3_text, speed_2, {top: "48%", y:-20, opacity: 1, ease: Linear.easeNone}, "scene3")

                .to(ocelotDevice_1, speed_1, {/*top: "58%",*/ opacity: 0.8, scale: 0.9,  ease: Linear.easeNone}, "scene4")

            // build pinned scene
            new ScrollMagic.Scene({
                triggerElement: '.ocelot-container-amazing',
                triggerHook:'onEnter',
                duration: (frame_count * offset_value) + 'px',
                reverse: true
            })
                .on("start", function (e) {
                     updateDotNavItem(ocelot6);
                    $(".ocelot-container-amazing").toggleClass("pinned");
                })
                .on("end", function (e) {
                    $(".ocelot-container-amazing").toggleClass("pinned");
                })
                .setPin('.ocelot-container-amazing')
                .setTween(ocelotAnimationAmazing)
                .addTo(controller);
        }

        if (ocelotContainer.length){
            var totalImagesCount = 30,
                frameDuration = 130,
                vid = $('#ocelot-video'),
                sprites = [];

            // define sprites
            for (var i=0; i <totalImagesCount; i++){
                sprites.push(avinger_theme_directory + "assets/images/ocelot/"+zeroPad(i, 3)+".jpg");
            }
            preload(sprites);

            ocelotContainer.find('.animation-container').addClass('animated');
            var ocelot1 = ocelotContainer.find('#ocelot-1'),
                ocelot1_top = ocelot1.find('.ani-top'),
                ocelot1_bottom = ocelot1.find('.ani-bottom'),
                ocelot2 = ocelotContainer.find('#ocelot-2'),
                ocelot2_bottom = ocelot2.find('.ani-bottom'),
                ocelot3 = ocelotContainer.find('#ocelot-3'),
                ocelot3_bottom = ocelot3.find('.ani-bottom'),
                ocelot4 = ocelotContainer.find('#ocelot-4'),
                ocelot5 = ocelotContainer.find('#ocelot-5'),
                ocelot4_top = ocelot4.find('.ani-top'),
                ocelot4_bottom = ocelot4.find('.ani-bottom'),
                ocelot4_item1 = ocelot4_bottom.find('.column-1'),
                ocelot4_item2 = ocelot4_bottom.find('.column-2'),
                circleBar1 = ocelot2.find('#circle-bar-1'),
                circleBar2 = ocelot2.find('#circle-bar-2'),
                doubleBar1 = ocelot3.find('#bar-double-1'),
                ocelot2_completed = false,
                ocelot3_completed = false,
                frame_count  = 80,
                offset_value = 40,
                speed_1 = 4;

            initDotNav(ocelotContainer);
            circleBar1.circleProgress({ value: 0 });
            circleBar2.circleProgress({ value: 0 });
            reset_bar_horizontal_double(doubleBar1);

            var ocelotAnimation = new TimelineMax()
                .add("scene1", 0)
                .add("scene2", 2)
                .add("scene2_progress", 6)
                .add("scene2_end", 8)
                .add("scene3", 10)
                .add("scene3_end", 16)
                .add("scene4", 18)
                .add("scene4_item1", 24)
                .add("scene4_item2", 26)
                .add("scene4_item3", 28)
                .add("scene4_end", 30)
                .set(ocelot2, {display:'table'}, "scene1")
                .set(ocelot4_item1, {className:"-=active"}, "scene1")
                .to(ocelot1_top, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone}, "scene1")  // in from left
                .to(ocelot1_bottom, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone}, "scene1")  // in from left
                .set(ocelot2, {zIndex: 1}, "scene2")

                .fromTo(ocelot2_bottom, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone,
                    onComplete: function(){
                        if (!ocelot2_completed){
                            ocelot2_completed = true;
                            circleBar1.circleProgress({ value: circleBar1.data("value") });
                            circleBar2.circleProgress({ value: circleBar2.data("value") });
                        }
                        updateDotNavItem(ocelot2);
                    },
                    onReverseComplete: function () {
                        updateDotNavItem(ocelot1);
                    }
                }, "scene2")
                .set(ocelot3, {display:'table'}, "scene2_end")
                .to(ocelot2_bottom, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone},  "scene2_end")  // in from left
                .set(ocelot3, {zIndex: 1}, "scene3")
                .fromTo(ocelot3_bottom, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone, onComplete: function(){
                    if (!ocelot3_completed){
                        ocelot3_completed = true;
                        bar_horizontal_double(doubleBar1);
                    }
                    updateDotNavItem(ocelot3);
                },
                    onReverseComplete: function () {
                        updateDotNavItem(ocelot2);
                    }
                }, "scene3")  // in from right
                .to(ocelot3_bottom, speed_1, {opacity: "1", y: 0, ease: Linear.easeNone},  "scene3_end")  // in from left
                .set(ocelot4, {display:'table'}, "scene3_end")
                .to(ocelot3_bottom, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone},  "scene3_end")  // in from left
                .set(ocelot3, {zIndex: 1}, "scene4")
                .fromTo(ocelot4_top, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone})
                .fromTo(ocelot4_bottom, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone, onComplete: function(){
                    updateDotNavItem(ocelot4);
                },
                    onReverseComplete: function () {
                        updateDotNavItem(ocelot3);
                    }
                }, "scene4")
                .set(ocelot4_item1, {className:"+=active"}, "scene4_item1")
                .set(ocelot4_item1, {className:"-=active"}, "scene4_item2")
                .set(ocelot4_item2, {className:"+=active",
                    onComplete: function () {
                        updateDotNavItem(ocelot5);
                    },
                    onReverseComplete: function () {
                        updateDotNavItem(ocelot4);
                    },
                }, "scene4_item2")
                .to(ocelot4_item2, speed_1, {zIndex:1}, "scene4_item3")
                .set(ocelot4_item2, {className:"-=active"}, "scene4_end")
                .to(ocelot4, 4, {opacity: 1})

            // build pinned scene
            new ScrollMagic.Scene({
                triggerElement: '.ocelot-container',
                triggerHook:'onEnter',
                duration: (frame_count * offset_value) + 'px',
                reverse: true
            })
                .on("start", function (e) {
                    updateDotNavItem(ocelot1);
                $(".ocelot-container").toggleClass("pinned");
            })
                .on("end", function (e) {
                $(".ocelot-container").toggleClass("pinned");
            })
                .setPin('.ocelot-container')
                .setTween(ocelotAnimation)
                .addTo(controller);

            var obj = {curImg: 0};

            // create tween
            var tween = TweenMax.to(obj, 0.5,
                {
                    curImg: sprites.length - 1,	// animate propery curImg to number of images
                    roundProps: "curImg",				// only integers so it can be used as an array index
                    repeat: 1,									// repeat 3 times
                    immediateRender: true,			// load first image automatically
                    ease: Linear.easeNone,			// show every image the same ammount of time
                    onUpdate: function () {
                        $("#ocelot-video-frame").attr("src", sprites[obj.curImg]); // set the image source
                    }
                }
            );

            new ScrollMagic.Scene({triggerElement: ".ocelot-container", duration: (frame_count * offset_value) + 'px'})
                .setTween(tween)
                .addTo(controller);
        }

        if (pantherisContainer.length){
            // select video element
            var frameNumber = 0,
                totalImagesCount = 220,
                frameDuration = 130,
                vid = $('#pantheris-video'),
                sprites = [];

            // define sprites
            for (var i=0; i <totalImagesCount; i++){
                sprites.push(avinger_theme_directory + "assets/images/pantheris/"+zeroPad(i, 3)+".jpg");
            }
            preload(sprites);

            pantherisContainer.find('.animation-container').addClass('animated');
            var pantheris1 = pantherisContainer.find('#pantheris-1'),
                pantheris1_top = pantheris1.find('.ani-top'),
                pantheris1_middle = pantheris1.find('.ani-middle'),
                pantheris1_bottom = pantheris1.find('.ani-bottom'),
                pantheris2 = pantherisContainer.find('#pantheris-2'),
                pantheris2_top = pantheris2.find('.ani-top'),
                pantheris2_middle = pantheris2.find('.ani-middle'),
                pantheris2_bottom = pantheris2.find('.ani-bottom'),
                pantheris3 = pantherisContainer.find('#pantheris-3'),
                pantheris3_top = pantheris3.find('.ani-top'),
                pantheris3_middle = pantheris3.find('.ani-middle'),
                pantheris3_bottom = pantheris3.find('.ani-bottom'),
                pantheris4 = pantherisContainer.find('#pantheris-4'),
                pantheris5 = pantherisContainer.find('#pantheris-5'),
                pantheris6 = pantherisContainer.find('#pantheris-6'),
                pantheris4_top = pantheris4.find('.ani-top'),
                pantheris4_middle = pantheris4.find('.ani-middle'),
                pantheris4_bottom = pantheris4.find('.ani-bottom'),
                pantheris4_item1 = pantheris4_bottom.find('.column-1'),
                pantheris4_item2 = pantheris4_bottom.find('.column-2'),
                pantheris4_item3 = pantheris4_bottom.find('.column-3'),
                pantheris2_completed = false,
                pantheris3_completed = false,
                frame_count  = 80,
                offset_value = 80,
                speed_1 = 4;

            initDotNav(pantherisContainer);
            pantheris2.find('#circle-bar-1').circleProgress({ value: 1 });
            pantheris2.find('#circle-bar-2').circleProgress({ value: 1 });
            pantheris2.find('.bar-v .bar-progress').css({height:pantheris2.find('.bar-v').data('start')+"%"});
            pantheris2.find('.bar-v .bar-txt').text(pantheris2.find('.bar-v').data('start')+"%");
            pantheris3.find('.circle-progress-a').circleProgress({value: 0});
            var progressBars = pantheris3.find('.progress-list .progress-bar');
            progressBars.each(function (e) {
                var el = $(this);
                el.css({width: el.data('start')+"%"});
                el.find('span').text(el.data('start')+"%");
            });

            var imgTimeLine = new TimelineMax({ paused: true }),
                imgHolder = $("#pantheris-video-frame");

            var pantherisAnimation = new TimelineMax()
                .add("scene1", 0)
                .add("scene2", 2)
                .add("scene2_progress", 6)
                .add("scene2_end", 8)
                .add("scene3", 10)
                .add("scene3_end", 16)
                .add("scene4", 18)
                .add("scene4_item1", 24)
                .add("scene4_item2", 26)
                .add("scene4_item3", 28)
                .add("scene4_end", 30)
                .set(pantheris2, {display:'table'}, "scene1")
                .set(pantheris4_item1, {className:"-=active"}, "scene1")
                .to(pantheris1_top, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone}, "scene1")  // in from left
                //.to(pantheris1_middle, speed_1, {opacity: "0", ease: Linear.easeNone}, "scene1")  // in from left
                .to(pantheris1_bottom, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone}, "scene1")  // in from left
                .set(pantheris2, {zIndex: 1}, "scene2")

                .fromTo(pantheris2_top, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone}, "scene2")  // in from right
                //.to(pantheris2_middle, speed_1, {opacity: "1", ease: Linear.easeNone}, "scene2")  // in from right
                .fromTo(pantheris2_bottom, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone,
                    onComplete: function(){
                        if (!pantheris2_completed){
                            pantheris2_completed = true;
                            bar_vertical(pantheris2.find('.bar-v'));
                            pantheris2.find('#circle-bar-1').circleProgress({ value: 0 });
                            pantheris2.find('#circle-bar-2').circleProgress({ value: 0 });
                        }
                        var imgTimeLine = new TimelineMax({ paused: true });
                        /*for (var i = 4, j = 0; i >= 0; i--) {
                            imgTimeLine.set(imgHolder, {attr:{src:sprites[i]}}, j);
                            j++;
                        }
                        TweenMax.to(imgTimeLine, 0.7, { progress:1, ease:Linear.easeNone, immediateRender: false });*/
                        updateDotNavItem(pantheris2);
                    },
                    onReverseComplete: function () {
                        var imgTimeLine = new TimelineMax({ paused: true });
                        /*for (var i = 0; i <= 4; i++) {
                            imgTimeLine.set(imgHolder, {attr:{src:sprites[i]}}, i);
                        }
                        TweenMax.to(imgTimeLine, 0.7, { progress:1, ease:Linear.easeNone, immediateRender: false });*/
                        updateDotNavItem(pantheris1);
                    }}, "scene2")
                .set(pantheris3, {display:'table'}, "scene2_end")
                .to(pantheris2_top, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone}, "scene2_end")  // in from left
                //.to(pantheris2_middle, speed_1, {opacity: "0", ease: Linear.easeNone},  "scene2_end")  // in from left
                .to(pantheris2_bottom, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone},  "scene2_end")  // in from left
                .set(pantheris3, {zIndex: 1}, "scene3")
                .fromTo(pantheris3_top, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone}, "scene3")  // in from right
                //.to(pantheris3_middle, speed_1, {opacity: "1", ease: Linear.easeNone}, "scene3")  // in from right
                .fromTo(pantheris3_bottom, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone, onComplete: function(){
                    if (!pantheris3_completed){
                        pantheris3_completed = true;
                        var progressBars = pantheris3.find('.progress-list .progress-bar');
                        progressBars.each(function (e) {
                            bar_horizontal(this);
                        });
                        pantheris3.find('.circle-progress-a').circleProgress({value: 0.989})
                    }
                    updateDotNavItem(pantheris3);
                    /*var imgTimeLine = new TimelineMax({ paused: true });
                    for (var i = 0; i <= 25; i++) {
                        imgTimeLine.set(imgHolder, {attr:{src:sprites[i]}}, i);
                    }
                    TweenMax.to(imgTimeLine, 1, { progress:1, ease:Linear.easeNone, immediateRender: false });*/
                },
                    onReverseComplete: function () {
                        /*var imgTimeLine = new TimelineMax({ paused: true });
                        for (var i = 25; i >= 0; i--) {
                            imgTimeLine.set(imgHolder, {attr:{src:sprites[i]}}, 25-i);
                        }
                        TweenMax.to(imgTimeLine, 1, { progress:1, ease:Linear.easeNone, immediateRender: false });*/
                        updateDotNavItem(pantheris2);
                    }
                }, "scene3")  // in from right

                .set(pantheris4, {display:'table'}, "scene3_end")
                .to(pantheris3_top, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone}, "scene3_end")  // in from left
                //.to(pantheris3_middle, speed_1, {opacity: "0", ease: Linear.easeNone},  "scene3_end")  // in from left
                .to(pantheris3_bottom, speed_1, {opacity: "0", y: -30, ease: Linear.easeNone},  "scene3_end")  // in from left
                .set(pantheris4, {zIndex: 1}, "scene4")
                .fromTo(pantheris4_top, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone}, "scene4")  // in from right
                //.to(pantheris4_middle, speed_1, {opacity: "1", ease: Linear.easeNone}, "scene4")  // in from right
                .fromTo(pantheris4_bottom, speed_1, {opacity: "0", y:30, ease: Linear.easeNone}, {opacity: "1", y:0, ease: Linear.easeNone, onComplete: function(){
                    updateDotNavItem(pantheris4);
                },
                    onReverseComplete: function () {
                        updateDotNavItem(pantheris3);
                    },
                    onStart: function () {

                    }
                }, "scene4")  // in from right
                .set(pantheris4_item1, {className:"+=active",
                    onStart: function () {
                        var imgTimeLine = new TimelineMax({ paused: true });
                        for (var i = 0; i <= 59; i++) {
                            imgTimeLine.set(imgHolder, {attr:{src:sprites[i]}}, i);
                        }
                        TweenMax.to(imgTimeLine, 1, { progress:1, repeat: 0, ease:Linear.easeNone, immediateRender: false, onUpdate: function () {
                        }});
                    },
                    onReverseComplete: function () {
                        var imgTimeLine1 = new TimelineMax({ paused: true });
                        for (var i = 59; i >= 0; i--) {
                            imgTimeLine1.set(imgHolder, {attr:{src:sprites[i]}});
                        }
                        TweenMax.to(imgTimeLine1, 1, { progress:1, repeat: 0, ease:Linear.easeNone, immediateRender: false, onComplete:function () {
                            imgHolder.attr('src', sprites[26]);
                        } });
                    }
                }, "scene4_item1")
                .set(pantheris4_item1, {className:"-=active",
                    onStart: function () {
                        var imgTimeLine = new TimelineMax({ paused: true });
                        for (var i = 60; i <= 135; i++) {
                            imgTimeLine.set(imgHolder, {attr:{src:sprites[i]}}, i);
                        }
                        TweenMax.to(imgTimeLine, 3, { progress:1, repeat: 0, ease:Linear.easeNone , immediateRender: false});

                    },
                    onReverseComplete: function () {
                        var imgTimeLine = new TimelineMax({ paused: true });
                        for (var i = 135; i >= 60; i--) {
                            imgTimeLine.set(imgHolder, {attr:{src:sprites[i]}});
                        }
                        TweenMax.to(imgTimeLine, 3, { progress:1,repeat: 0, ease:Linear.easeNone, immediateRender: false, onComplete:function () {
                            imgHolder.attr('src', sprites[60]);
                        } });
                    }
                }, "scene4_item2")
                .set(pantheris4_item2, {className:"+=active",
                    onComplete: function () {
                        updateDotNavItem(pantheris5);
                    },
                    onReverseComplete: function () {
                        updateDotNavItem(pantheris4);
                    },
                }, "scene4_item2")
                .to(pantheris4_item2, speed_1, {zIndex:1,
                    onStart:function () {
                        var imgTimeLine = new TimelineMax({ paused: true });
                        for (var i = 136; i <= 219; i++) {
                            imgTimeLine.set(imgHolder, {attr:{src:sprites[i]}}, i);
                        }
                        TweenMax.to(imgTimeLine, 3, { progress:1, ease:Linear.easeNone, immediateRender: false });
                    },
                    onReverseComplete: function () {
                        var imgTimeLine42 = new TimelineMax({ paused: true });
                        for (var i = 219; i >= 136; i--) {
                            imgTimeLine42.set(imgHolder, {attr:{src:sprites[i]}});
                        }
                        TweenMax.to(imgTimeLine42, 3, { progress:1, ease:Linear.easeNone, immediateRender: false, onComplete:function () {
                            imgHolder.attr('src', sprites[136]);
                        }  });
                    }
                }, "scene4_item3")
                .set(pantheris4_item2, {className:"-=active",
                    onStart: function () {


                    }
                }, "scene4_end")
                .set(pantheris4_item3, {className:"+=active",
                    onComplete: function () {
                        updateDotNavItem(pantheris6);
                    },
                    onReverseComplete: function () {
                        updateDotNavItem(pantheris5);
                    }
                }, "scene4_end")
                .to(pantheris4, 4, {opacity: 1})
                /*.set(pantheris4_item2, {className:"+=active"}, "scene4_end")
                .set(pantheris4_item1, {className:"+=active"}, "scene4_end")*/;

            // build pinned scene
            new ScrollMagic.Scene({
                triggerElement: '.pantheris-container',
                triggerHook:'onEnter',
                duration: (frame_count * offset_value) + 'px',
                reverse: true
            })
                .on("start", function (e) {
                    $(".pantheris-container").toggleClass("pinned");
                    updateDotNavItem(pantheris1);
                })
                .on("end", function (e) {
                    $(".pantheris-container").toggleClass("pinned");
                })
                .setPin('.pantheris-container')
                .setTween(pantherisAnimation)
                //.addIndicators()
                .addTo(controller);

            var parent = pantheris1.closest('.scrollmagic-pin-spacer'),
                parentHeight = parent.outerHeight(),
                counter = parent.find('.animation-view').length,
                height = $(window).height(),
                heightDelta = parentHeight/counter,
                step = heightDelta / height,
                id = 4,
                delta = height * id,
                pantheris_video_delay = (parent.offset().top + delta * step);


            /*var obj = {curImg: 0};

            // create tween
            var tween = TweenMax.to(obj, 0.5,
                {
                    curImg: sprites.length - 1,	// animate propery curImg to number of images
                    roundProps: "curImg",				// only integers so it can be used as an array index
                    repeat: 1,									// repeat 3 times
                    immediateRender: true,			// load first image automatically
                    ease: Linear.easeNone,			// show every image the same ammount of time
                    onUpdate: function () {
                        $("#pantheris-video-frame").attr("src", sprites[obj.curImg]); // set the image source
                    }
                }
            );

            new ScrollMagic.Scene({triggerElement: ".pantheris-container", duration: (frame_count * offset_value) + 'px', offset: pantheris_video_delay})
                .setTween(tween)
                .addTo(controller);
                */
        }
    }

    $('#popupVideo').on('shown.bs.modal', function (event) {
        var button = $(event.relatedTarget),
            recipient = button.data('video');
        jQuery("#popupVideo .modal-body").empty();
        $("<iframe />")
            .attr("id", "videoIframe")
            .attr("src", "https://player.vimeo.com/video/"+recipient)
            .appendTo(jQuery("#popupVideo .modal-body"))
            .vimeoLoad() //call this function after appending your iframe
            .vimeo("play");
    });
    $('#popupVideo').on('hidden.bs.modal', function (event) {
        jQuery("#popupVideo .modal-body iframe").vimeo("pause");
    });
}(jQuery));